import { createI18n } from 'vue-i18n';
import enTranslations from './en-EN.json';
import frTranslations from './fr-FR.json';

const messages = {
  en: enTranslations,
  fr: frTranslations
};

export const i18n = createI18n({
  globalInjection: true,
  legacy: false, // set to `false` to use Composition API
  locale: 'fr',
  fallbackLocale: 'fr',
  messages
});
